// eslint-disable-next-line no-useless-escape
export const EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const ID_CODE_REGEX = /[1-6][0-9]{2}(0[1-9]|1[012])(0[1-9]|[12][0-9]|3[01])[0-9]{4}/;
export const ID_CODE_PREFIX = 'ee';

export const BLACK_BOX_UPLOAD_DESCRIPTION_MAX_LENGTH = '500';
export const NO_WHITESPACE_REGEX = /.*[^ ].*/;
